export const policeData = citiesData =>
  fetch(
    "https://polisen.se/api/events"
  )
    .then(response => response.json()).then()

// export const policeData = () => {
//   let options = {
//     url: "https://polisen.se/api/events"
//   }

//   let defaultOptions = {
//     url: "",
//     method: "GET",
//     mode: "cors",
//     headers: {
//       "Access-Control-Allow-Origin": "*"
//     },
//     body: null
//   };

//   let header = new Headers({
//     "Access-Control-Allow-Origin": "",
//     "Content-Type": "application/json"
//   });
//   let opt = Object.assign({}, defaultOptions, options); //将默认的参数和传过来的合并在一起
//   let sentData = {
//     method: opt.method,
//     mode: "cors",
//     header: header,
//     //body: opt.body || ""
//   };
//   return new Promise((reslove, reject) => {
//     fetch(opt.url, sentData)
//       .then(response => {
//         let json = response.json()
//         console.log(json)
//         return json
//       })
//       .then(responseText => {
//         let resp =
//           typeof responseText === "string"
//             ? JSON.parse(responseText)
//             : responseText;
//         console.log(resp);
//         reslove(resp);
//       })
//       .catch(err => {
//         console.error(err);
//         reject(err);
//       });
//   }).catch(err => {
//     console.error(err);
//   });
// };



// WEBPACK FOOTER //
// ./src/services/police-api.js